<template>
  <header class="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-16">
        <!-- Logo Xiaomi -->
        <div class="flex-shrink-0">
          <router-link to="/">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-auto" viewBox="-200.008 -199.727 512 512">
              <g>
                <path fill="#FF6900" d="M258.626-146.231c-48.304-48.118-117.759-53.496-202.634-53.496c-84.982,0-154.542,5.44-202.826,53.688c-48.277,48.228-53.174,117.676-53.174,202.561c0,84.899,4.897,154.368,53.194,202.613c48.281,48.255,117.833,53.139,202.806,53.139c84.974,0,154.514-4.884,202.795-53.139c48.294-48.254,53.205-117.714,53.205-202.613C311.992-28.472,307.028-97.995,258.626-146.231L258.626-146.231z"/>
                <path fill="#FFFFFF" d="M204.546-41.122c1.759,0,3.223,1.417,3.223,3.161v189.386c0,1.715-1.464,3.139-3.223,3.139H163.05c-1.781,0-3.228-1.424-3.228-3.139V-37.961c0-1.743,1.446-3.161,3.228-3.161H204.546z M24.468-41.122c31.303,0,64.033,1.435,80.176,17.59c16.143,16.154,17.656,47.549,17.656,78.286v96.671c0,1.715-1.446,3.139-3.219,3.139h-41.49c-1.777,0-3.229-1.424-3.229-3.139V53.09c-0.044-17.167-1.031-34.81-9.884-43.692c-7.62-7.641-21.839-9.391-36.625-9.754h-75.21c-1.764,0-3.208,1.419-3.208,3.136v148.645c0,1.715-1.462,3.139-3.237,3.139h-41.516c-1.774,0-3.201-1.424-3.201-3.139V-37.961c0-1.743,1.426-3.161,3.201-3.161H24.468z M33.755,34.305c1.766,0,3.201,1.413,3.201,3.143v113.977c0,1.715-1.436,3.139-3.201,3.139H-9.829c-1.792,0-3.228-1.424-3.228-3.139V37.448c0-1.73,1.436-3.143,3.228-3.143H33.755z"/>
              </g>
            </svg>
          </router-link>
        </div>

        <!-- Navigation Desktop -->
        <nav class="hidden lg:flex items-center space-x-4 xl:space-x-6">
          <router-link
            to="/"
            class="text-gray-900 hover:text-orange-500 font-medium text-xs lg:text-sm whitespace-nowrap transition-colors"
            :class="{ 'text-orange-500': currentPath === '/' }"
          >
            Accueil
          </router-link>
          <a
            href="https://oxoformdocs.fra1.digitaloceanspaces.com/691aec3fe85184ee57dbd4c4/modalites.pdf"
            target="_blank"
            rel="noopener noreferrer"
            class="text-gray-600 hover:text-orange-500 font-medium text-xs lg:text-sm whitespace-nowrap transition-colors"
          >
            Modalités
          </a>
          <template v-if="!isWaitPage">
            <router-link
              to="/produits-eligibles"
              class="text-gray-600 hover:text-orange-500 font-medium text-xs lg:text-sm whitespace-nowrap transition-colors"
              :class="{ 'text-orange-500': currentPath === '/produits-eligibles' }"
            >
              Produits éligibles
            </router-link>
            <button
              @click="statusStore.openSuiviModal()"
              class="text-gray-600 hover:text-orange-500 font-medium text-xs lg:text-sm whitespace-nowrap transition-colors"
            >
              Suivi de participation
            </button>
            <router-link
              to="/partenaires"
              class="text-gray-600 hover:text-orange-500 font-medium text-xs lg:text-sm whitespace-nowrap transition-colors"
              :class="{ 'text-orange-500': currentPath === '/partenaires' }"
            >
              Nos enseignes partenaires
            </router-link>
            <router-link
              to="/contact"
              class="text-gray-600 hover:text-orange-500 font-medium text-xs lg:text-sm whitespace-nowrap transition-colors"
              :class="{ 'text-orange-500': currentPath === '/contact' }"
            >
              Contactez-nous
            </router-link>
          </template>
        </nav>

        <!-- Hamburger Menu Mobile -->
        <button
          @click="toggle"
          class="lg:hidden p-2 rounded-md text-gray-600 hover:text-orange-500 focus:outline-none"
        >
          <i class="fa-solid fa-bars text-xl"></i>
        </button>
      </div>
    </div>

    <!-- Mobile Menu Drawer -->
    <Teleport to="body">
      <Drawer @close="toggle" align="right" :closeable="true">
        <div v-if="open" class="p-6 bg-white min-h-screen">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-12 h-auto m-auto mb-6" viewBox="-200.008 -199.727 512 512">
            <g>
              <path fill="#FF6900" d="M258.626-146.231c-48.304-48.118-117.759-53.496-202.634-53.496c-84.982,0-154.542,5.44-202.826,53.688c-48.277,48.228-53.174,117.676-53.174,202.561c0,84.899,4.897,154.368,53.194,202.613c48.281,48.255,117.833,53.139,202.806,53.139c84.974,0,154.514-4.884,202.795-53.139c48.294-48.254,53.205-117.714,53.205-202.613C311.992-28.472,307.028-97.995,258.626-146.231L258.626-146.231z"/>
              <path fill="#FFFFFF" d="M204.546-41.122c1.759,0,3.223,1.417,3.223,3.161v189.386c0,1.715-1.464,3.139-3.223,3.139H163.05c-1.781,0-3.228-1.424-3.228-3.139V-37.961c0-1.743,1.446-3.161,3.228-3.161H204.546z M24.468-41.122c31.303,0,64.033,1.435,80.176,17.59c16.143,16.154,17.656,47.549,17.656,78.286v96.671c0,1.715-1.446,3.139-3.219,3.139h-41.49c-1.777,0-3.229-1.424-3.229-3.139V53.09c-0.044-17.167-1.031-34.81-9.884-43.692c-7.62-7.641-21.839-9.391-36.625-9.754h-75.21c-1.764,0-3.208,1.419-3.208,3.136v148.645c0,1.715-1.462,3.139-3.237,3.139h-41.516c-1.774,0-3.201-1.424-3.201-3.139V-37.961c0-1.743,1.426-3.161,3.201-3.161H24.468z M33.755,34.305c1.766,0,3.201,1.413,3.201,3.143v113.977c0,1.715-1.436,3.139-3.201,3.139H-9.829c-1.792,0-3.228-1.424-3.228-3.139V37.448c0-1.73,1.436-3.143,3.228-3.143H33.755z"/>
            </g>
          </svg>
          <nav class="flex flex-col space-y-4">
            <router-link
              to="/"
              @click.native="toggle"
              class="text-gray-900 hover:text-orange-500 font-medium text-base"
            >
              Accueil
            </router-link>
            <a
              href="https://oxoformdocs.fra1.digitaloceanspaces.com/691aec3fe85184ee57dbd4c4/modalites.pdf"
              target="_blank"
              rel="noopener noreferrer"
              @click="toggle"
              class="text-gray-900 hover:text-orange-500 font-medium text-base"
            >
              Modalités
            </a>
            <template v-if="!isWaitPage">
              <router-link
                to="/produits-eligibles"
                @click.native="toggle"
                class="text-gray-900 hover:text-orange-500 font-medium text-base"
              >
                Produits éligibles
              </router-link>
              <button
                @click="statusStore.openSuiviModal(); toggle();"
                class="text-left text-gray-900 hover:text-orange-500 font-medium text-base"
              >
                Suivi de participation
              </button>
              <router-link
                to="/partenaires"
                @click.native="toggle"
                class="text-gray-900 hover:text-orange-500 font-medium text-base"
              >
                Nos enseignes partenaires
              </router-link>
              <router-link
                to="/contact"
                @click.native="toggle"
                class="text-gray-900 hover:text-orange-500 font-medium text-base"
              >
                Contactez-nous
              </router-link>
            </template>
          </nav>
        </div>
      </Drawer>
    </Teleport>

    <!-- Modal Suivi de participation -->
    <Teleport to="body">
      <transition name="popup-fade">
        <div
          v-if="statusStore.showSuiviModal"
          class="fixed inset-0 z-[100] flex items-center justify-center"
        >
          <!-- Overlay -->
          <div
            class="absolute inset-0 bg-black bg-opacity-70"
            @click="closeSuiviModal"
          ></div>

          <!-- Modal -->
          <transition name="popup-scale" appear>
            <div
              v-if="statusStore.showSuiviModal"
              class="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6"
            >
          <!-- Bouton fermer -->
          <button
            @click="closeSuiviModal"
            class="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <i class="fa-solid fa-xmark text-xl"></i>
          </button>

          <!-- Formulaire -->
          <div v-if="!suiviSuccess">
            <h2 class="text-xl font-bold text-gray-900 text-center mb-4">
              Suivi de ma participation
            </h2>

            <p class="text-gray-600 text-center text-sm mb-6">
              Merci de renseigner l'adresse email avec laquelle vous avez
              participé. Un email contenant le lien de suivi vous sera envoyé.
            </p>

            <form @submit.prevent="submitSuivi">
              <input
                type="email"
                v-model="suiviEmail"
                required
                placeholder="Ex : maurice@dupont.com"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-colors"
              />

              <span v-if="suiviError" class="block text-red-500 text-sm mt-2">
                {{ suiviError }}
              </span>

              <button
                type="submit"
                :disabled="suiviLoading"
                class="w-full mt-6 bg-orange-500 hover:bg-orange-600 disabled:bg-orange-300 text-white font-semibold py-3 px-6 rounded-lg transition-colors flex items-center justify-center"
              >
                <span v-if="suiviLoading" class="flex items-center gap-2">
                  <svg class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Envoi en cours...
                </span>
                <span v-else>Recevoir mon lien</span>
              </button>
            </form>
          </div>

          <!-- Succès -->
          <div v-else class="py-4 text-center">
            <div class="success-animation mb-6">
              <svg
                class="checkmark"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 52 52"
              >
                <circle
                  class="checkmark__circle"
                  cx="26"
                  cy="26"
                  r="25"
                  fill="none"
                />
                <path
                  class="checkmark__check"
                  fill="none"
                  d="M14.1 27.2l7.1 7.2 16.7-16.8"
                />
              </svg>
            </div>

            <h2 class="text-xl font-bold text-gray-900 mb-3">Email envoyé !</h2>
            <p class="text-gray-600 text-sm leading-relaxed mb-6">
              Si votre adresse email est associée à une participation, vous recevrez un email avec le lien de suivi dans quelques instants.
            </p>

            <button
              @click="closeSuiviModal"
              class="bg-gray-900 hover:bg-gray-800 text-white font-semibold py-3 px-8 rounded-lg transition-colors"
            >
              Fermer
            </button>
          </div>
            </div>
          </transition>
        </div>
      </transition>
    </Teleport>
  </header>
</template>

<script>
import axios from "axios";
import Drawer from "vue-simple-drawer";
import Teleport from "vue2-teleport";
import { useStatusStore } from "@/stores/status";

export default {
  name: "header-view",
  components: {
    Drawer,
    Teleport,
  },
  data() {
    return {
      open: false,
      suiviEmail: "",
      suiviError: "",
      suiviLoading: false,
      suiviSuccess: false,
      operationId: "691aec3fe85184ee57dbd4c4",
      statusStore: useStatusStore(),
    };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
    closeSuiviModal() {
      this.statusStore.closeSuiviModal();
      this.suiviEmail = "";
      this.suiviError = "";
      this.suiviSuccess = false;
    },
    async submitSuivi() {
      this.suiviError = "";

      if (!this.suiviEmail) {
        this.suiviError = "Veuillez entrer votre adresse email.";
        return;
      }

      // Validation email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.suiviEmail)) {
        this.suiviError = "Veuillez entrer une adresse email valide.";
        return;
      }

      this.suiviLoading = true;

      try {
        const formDatas = {
          operationId: this.operationId,
          email: this.suiviEmail,
          lang: "fr",
        };

        const { data } = await axios.post(
          "https://api-gabarit.promo.dev/api/operations-custom/promodev-send-contact/getlinkstatus",
          formDatas
        );

        if (data) {
          this.suiviSuccess = true;
          this.suiviEmail = "";
        } else {
          this.suiviError = "Cette adresse email n'est associée à aucune participation.";
        }
      } catch (e) {
        console.error("Erreur:", e);
        this.suiviError = "Cette adresse email n'est associée à aucune participation.";
      } finally {
        this.suiviLoading = false;
      }
    },
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
    isWaitPage() {
      return this.$route.path === '/wait';
    },
  },
};
</script>

<style scoped>
.checkmark {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  border-radius: 50%;
  display: block;
  stroke-width: 2;
  stroke: #22c55e;
  stroke-miterlimit: 10;
  animation: fill 0.4s ease-in-out 0.4s forwards, scale 0.3s ease-in-out 0.9s both;
}

.checkmark__circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 2;
  stroke-miterlimit: 10;
  stroke: #22c55e;
  fill: none;
  animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark__check {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes scale {
  0%, 100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}

@keyframes fill {
  100% {
    box-shadow: inset 0 0 0 100px transparent;
  }
}

/* Popup animations */
.popup-fade-enter-active,
.popup-fade-leave-active {
  transition: opacity 0.3s ease;
}

.popup-fade-enter,
.popup-fade-leave-to {
  opacity: 0;
}

.popup-scale-enter-active {
  animation: popup-in 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.popup-scale-leave-active {
  animation: popup-out 0.25s ease-in;
}

@keyframes popup-in {
  0% {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes popup-out {
  0% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
  100% {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
}
</style>
